import React, { useState, useEffect } from 'react';
import Ticker from '../home/Ticker';
import Hero from '../home/Hero';
import MileMarkers from '../home/MileMarkers';
import MythDesk from '../home/MythDesk';
import ToolsWall from '../home/ToolsWall';
import RoastSection from '../home/RoastSection';
import DealTeaser from '../home/DealTeaser';
import QuizRow from '../home/QuizRow';
import KitSection from '../home/KitSection';
import ExploreLinks from '../home/ExploreLinks';
import ClosingCTA from '../home/ClosingCTA';

/**
 * The homepage (redesign "F"): a tabloid fact-check desk with the mascot as
 * its cover star. The hero's two doors serve the two reasons people come
 * back: settle an argument (share a verdict) or get help buying.
 */
export const Main = ({ selectedPart }) => {
  // The header's "Myths"/"Search" actions, plus the hero's "Read the myths",
  // all route through the desk's selectedPart handler.
  const [part, setPart] = useState('');

  useEffect(() => {
    if (selectedPart) setPart(selectedPart);
  }, [selectedPart]);

  const seeMyths = () => {
    setPart('content');
    setTimeout(() => setPart(''), 500);
  };

  return (
    <main className="fi-home">
      <Ticker />
      <Hero onSeeMyths={seeMyths} />
      <MileMarkers />
      <MythDesk selectedPart={part} />
      <ToolsWall />
      <RoastSection />
      <DealTeaser />
      <QuizRow />
      <KitSection />
      <ExploreLinks />
      <ClosingCTA />
    </main>
  );
};
